export const EVENT_OBJECT_TYPES = {
  DR: 'Driver',
  AS: 'Assignment',
  SH: 'Shipment',
  ST: 'Stop',
  US: 'User',
  CL: 'Client',
  AP: 'Application',
  WO: 'Worker',
  EH: 'Event Handler',
  DS: 'DSP',
  DB: 'Direct Booking',
  SC: 'Schedule',
  FC: 'Forecast',
  HB: 'Health Benefits',
  PF: 'Prefix',
  ET: 'Email Template',
  PUT: 'Pickup Template',
};
